<template>
    <div v-if="wappShow" id="wapp" :class="listDataBorder ? '' : 'list-border-no'">
        <router-view />
        <Watermark />
        <!-- <WatermarkConfig /> -->
        <DefaultDialog />
        <CCLockScreen v-if="isLocked" />
        <CCUiStyleSetting />
    </div>
</template>

<script>
import Watermark from './common/components/Watermark'
// import WatermarkConfig from './common/components/Watermark/WatermarkConfig'
import DefaultDialog from '@/wapp/common/components/DefaultDialog/index'
// import LockScreen from '@/wapp/common/components/LockScreen/index'
import { listDataBorder } from './settings'
export default {
    name: 'Wapp',
    components: {
        Watermark,
        // WatermarkConfig,
        DefaultDialog
        // LockScreen
    },
    data() {
        return {
            wappShow: true,
            listDataBorder: listDataBorder,
            levelingLock: 0,
            isLocked: false,
            inactivityTimer: null, // 不活动定时器
            intervalTimer: null // 定时器变量
        }
    },
    computed: {
        curUser() {
            return this.$store.getters.loginUser
        }
    },
    watch: {
        $route: {
            immediate: true,
            deep: true,
            handler(val) {
                // console.log('val===>', val)
                if (val.path === '/login') {
                    this.clearInactivityTimer()
                    clearTimeout(this.intervalTimer)
                    localStorage.removeItem('isLocked') // 清除锁屏状态
                    window.removeEventListener('mousemove', this.resetInactivityTimer)
                    window.removeEventListener('keydown', this.resetInactivityTimer)
                    window.removeEventListener('click', this.resetInactivityTimer)
                }
            }
        }
    },
    created() {
        // 追悼样式
        //     this.$http({
        //         method: 'GET',
        //         url: '/base/styleConfig/ifOpenMourning'
        //     }).then(res => {
        //         if (res.code === 'success') {
        //             if (res.body.rest) {
        //                 const html = document.getElementsByTagName('html')
        //                 html[0].style.filter = 'gray'
        //                 html[0].style['-webkit-filter'] = 'grayscale(100%)'
        //                 console.log(html, 'html')
        //             }
        //         } else {
        //             this.$message.error(res.message)
        //         }
        //     })
        this.$bus.on('setLockedFn', this.setLockedFn)
        this.$bus.on('refresh', this.refresh)
    },
    mounted() {
        window.$wapp = this
        if (localStorage.getItem('isLocked')) {
            this.isLocked = localStorage.getItem('isLocked') === 'true' // 从localStorage读取锁屏状态
        }
        setTimeout(() => {
            this.getData()
        }, 1000)

        if (this.isLocked) {
            //加载页面时判断是否是锁屏状态 是则开启
            this.intervalTimer = setInterval(() => {
                this.periodicTask()
            }, 3000)
        }
    },
    beforeDestroy() {
        this.clearInactivityTimer()
        window.removeEventListener('mousemove', this.resetInactivityTimer)
        window.removeEventListener('keydown', this.resetInactivityTimer)
        window.removeEventListener('click', this.resetInactivityTimer)
        clearTimeout(this.intervalTimer)
        this.$bus.off('setLockedFn', this.setLockedFn)
        this.$bus.off('refresh', this.refresh)
        localStorage.removeItem('isLocked') // 清除锁屏状态
    },

    methods: {
        setLockedFn() {
            //点击锁屏
            this.isLocked = true
            this.intervalTimer = setInterval(() => {
                //锁屏开启定时
                this.periodicTask()
            }, 3000)
            localStorage.setItem('isLocked', 'true') // 保存锁屏状态到localStorage
            this.clearInactivityTimer()
            window.removeEventListener('mousemove', this.resetInactivityTimer)
            window.removeEventListener('keydown', this.resetInactivityTimer)
            window.removeEventListener('click', this.resetInactivityTimer)
        },
        periodicTask() {
            // console.log('定时任务执行了', document.querySelector('#LockScreen'), this.isLocked)
            if (!document.querySelector('#LockScreen') && this.isLocked) {
                this.wappShow = false
                this.$nextTick(() => {
                    this.wappShow = true
                })
            }
        },
        refresh() {
            clearTimeout(this.intervalTimer)
            setTimeout(() => {
                this.isLocked = false
                localStorage.removeItem('isLocked') // 清除锁屏状态
                this.startInactivityTimer()
                window.addEventListener('mousemove', this.resetInactivityTimer)
                window.addEventListener('keydown', this.resetInactivityTimer)
                window.addEventListener('click', this.resetInactivityTimer)
            }, 500)

            // console.log('this.curUser====>', this.curUser)
        },
        getData() {
            // this.$http({
            // // 访问用户基本设置信息
            //     method: 'GET',
            //     contentType: 'application/x-www-form-urlencoded',
            //     params: { id: this.curUser.userId },
            //     url: 'base/user/getById'
            // }).then(
            //     (response) => {
            //         if (response.code === 'success') {
            // if (response.body.vo.levelingLock > 0) {
            if (this.curUser.levelingLock > 0) {
                // 分钟转化为秒

                // this.levelingLock = response.body.vo.levelingLock * 60 * 1000
                this.levelingLock = this.curUser.levelingLock * 60 * 1000
                // this.levelingLock = 6000
                if (this.isLocked || !this.levelingLock) return
                this.startInactivityTimer()
                window.addEventListener('mousemove', this.resetInactivityTimer)
                window.addEventListener('keydown', this.resetInactivityTimer)
                window.addEventListener('click', this.resetInactivityTimer)
            }
            //         } else {
            //             this.$message.error(response.message)
            //         }
            //     },
            //     (err) => {
            //         console.log(err)
            //     }
            // )
        },
        startInactivityTimer() {
            // console.log('this.levelingLock===>', this.levelingLock)
            if (this.levelingLock > 0) {
                this.inactivityTimer = setTimeout(() => {
                    this.isLocked = true
                    this.intervalTimer = setInterval(() => {
                        //锁屏开启定时
                        this.periodicTask()
                    }, 3000)
                    localStorage.setItem('isLocked', 'true') // 保存锁屏状态到localStorage
                    this.clearInactivityTimer()
                    window.removeEventListener('mousemove', this.resetInactivityTimer)
                    window.removeEventListener('keydown', this.resetInactivityTimer)
                    window.removeEventListener('click', this.resetInactivityTimer)
                }, this.levelingLock) // this.levelingLock  无操作锁屏时长（毫秒）
            }
        },
        resetInactivityTimer() {
            clearTimeout(this.inactivityTimer)
            this.isLocked = false
            localStorage.removeItem('isLocked') // 清除锁屏状态
            this.startInactivityTimer()
        },
        clearInactivityTimer() {
            clearTimeout(this.inactivityTimer)
        }
    }
}
</script>
<style>
:root {
    --personh: 106px;
    --sidebar-width: auto;
}
.demonstration {
    font-size: var(--portalFontSize14);
}
.el-dialog__title {
    padding-left: 40px;
}
.el-dialog__title .el-button {
    display: none;
}
.el-dialog .el-dialog__header {
    background-color: #f2f5fb !important;
}
.el-dialog__wrapper .el-dialog__title::before {
    content: '';
    width: 30px;
    display: inline-block;
    height: 30px;
    background: url('~public/images/systemLogoAll.png') no-repeat;
    background-size: cover;
    position: absolute;
    top: 12.5px;
    left: 20px;
}
.el-dialog__wrapper.select-ztree-dialog .el-dialog__title::before {
    content: '';
    width: 30px;
    display: inline-block;
    height: 30px;
    background: url('~public/images/systemLogoSelect.png') no-repeat;
    background-size: cover;
    position: absolute;
    top: 12.5px;
    left: 20px;
}
</style>
